import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setCustomSignatureClientData, saveCustomSignatures, savePrFormsCustom } from '../store/customSignature.actions'

export function* getCustomSignatures(pcrDoc: IPcr) {
  const customFormsSignature = pcrDoc.prFormsSignature
  const formsCustom = pcrDoc.prFormsCustom
  if (customFormsSignature && formsCustom && customFormsSignature.length > 0 && formsCustom.length > 0) {
    yield put(saveCustomSignatures(customFormsSignature))
    yield put(savePrFormsCustom(formsCustom))
    yield put(setCustomSignatureClientData(pcrDoc.__customSignatureClientData))
  }
}
